import { Card, Tag, Typography, Space } from "antd";
import { useHistory } from "react-router-dom";
import { useDraggable } from "@dnd-kit/core";
import { InboxOutlined, TruckOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import { ORIGEN_CONFIG } from "../../../../Components/VentaOnlineCard";

const { Text } = Typography;

const TarjetaGrupoInsumos = ({
  venta,
  envio,
  insumos,
  estado,
  onSeguirEmpaquetando,
  onVerEstadoGeneral,
}) => {
  const history = useHistory();
  const faltaEmpaquetar = estado === 1;
  const yaEntregado = estado === 5;
  const origenCfg = ORIGEN_CONFIG[envio.origen] || ORIGEN_CONFIG.bodega_local;

  const uniqueId = `${venta._id}-${envio.origen}-grupo-${estado}`;
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: uniqueId,
      disabled: yaEntregado,
      data: { venta, envio, tipo: "grupo", estadoGrupo: estado, insumosGrupo: insumos },
    });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        zIndex: 999,
        opacity: isDragging ? 0.5 : 1,
      }
    : undefined;

  const irAEntregarInsumos = (e) => {
    e.stopPropagation();
    history.push("/panel/entregarInsumosVenta", { id: venta._id });
  };

  return (
    <div
      ref={setNodeRef}
      style={{ ...style, cursor: yaEntregado ? "default" : "grab" }}
      {...listeners}
      {...attributes}
    >
      <Card
        size="small"
        onContextMenu={(e) => {
          e.preventDefault();
          if (onVerEstadoGeneral) onVerEstadoGeneral();
        }}
        style={{
          borderRadius: 8,
          marginBottom: 4,
          border: yaEntregado ? "1px dashed #b7eb8f" : "1px dashed #d9d9d9",
          backgroundColor: yaEntregado ? "#f6ffed" : "#fafafa",
          width: "100%",
        }}
        bodyStyle={{ padding: "8px 10px" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
          <Text strong style={{ fontSize: 12 }}>
            {venta.serieNumero || "S/F"}
          </Text>
          <Space size={4}>
            <Tag color={yaEntregado ? "green" : "orange"} style={{ fontSize: 9, margin: 0 }}>
              {yaEntregado ? "COMPLETADO" : "PENDIENTE"}
            </Tag>
            <Tag color={origenCfg.antd} style={{ fontSize: 9, margin: 0 }}>
              {origenCfg.label}
            </Tag>
          </Space>
        </div>
        <Text style={{ fontSize: 11, color: "#8c8c8c", display: "block", marginBottom: 8 }}>
          {venta.clienteOnline?.nombre} {venta.clienteOnline?.apellidoPaterno}
        </Text>
        <Tag
          icon={yaEntregado ? <CheckCircleOutlined /> : <InboxOutlined />}
          color={yaEntregado ? "green" : faltaEmpaquetar ? "orange" : "blue"}
          style={{ fontSize: 10, whiteSpace: "normal", marginBottom: 8 }}
        >
          {yaEntregado
            ? `${insumos.length} insumo(s) ya entregados`
            : faltaEmpaquetar
              ? `${insumos.length} insumo(s) sin empaquetar`
              : `${insumos.length} insumo(s) empaquetados, esperando entrega`}
        </Tag>
        {!yaEntregado && (
          <div style={{ textAlign: "center" }}>
            {faltaEmpaquetar ? (
              <ButtonItem
                size="small"
                naranja
                icon={<InboxOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  onSeguirEmpaquetando(venta, envio);
                }}
                style={{ height: 24, padding: "0 10px" }}
              >
                Seguir Empaquetando
              </ButtonItem>
            ) : (
              <ButtonItem
                size="small"
                morado
                icon={<TruckOutlined />}
                onClick={irAEntregarInsumos}
                style={{ height: 24, padding: "0 10px" }}
              >
                Ir a Entregar Insumos
              </ButtonItem>
            )}
          </div>
        )}
      </Card>
    </div>
  );
};

export default TarjetaGrupoInsumos;
